// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "@/store/";
import core from "@/utils/core"; // 引入生成二维码接口
import VueClipboard from "vue-clipboard2"; // 引入剪贴板
import GeminiScrollbar from "vue-gemini-scrollbar"; // 引入滚动条

// 引入 museUI
import MuseUI from 'muse-ui';
import 'muse-ui/dist/muse-ui.css';

Vue.use(MuseUI);


// 引入element-ui
import {
  Button,
  Breadcrumb,
  BreadcrumbItem,
  InputNumber,
  Input,
  Divider,
  Tag,
  Collapse,
  CollapseItem,
  Message,
  Dialog,
  Popover,
  Upload,
  MessageBox
} from "element-ui";

// element-ui
Vue.use(Button);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(InputNumber);
Vue.use(Input);
Vue.use(Divider);
Vue.use(Tag);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Dialog);
Vue.use(Popover);
Vue.use(Upload);

// 滚动条
Vue.use(GeminiScrollbar);

// 剪贴板
Vue.use(VueClipboard);

// element-ui
Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;

// 自定义 生成二维码
Vue.prototype.$core = core;
// element 提示框
Vue.prototype.$confirm = MessageBox.confirm;

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: {
    App
  },
  template: "<App/>",
  mounted() {
    document.dispatchEvent(new Event("render-event"));
  },
  methods: {
    // 过滤图片
    tomedia(url) {
      const imgUrl = "https://img.weilian.xin/";
      if (!url) return "";
      if (url && url.includes("http")) return url;
      return (url = imgUrl + url);
    },
    // 页面跳转 放在这里 所有页面可以通过 `this.$root.jump` 访问
    // jump(path, query) {
    //   if (!path) return undefined
    //   this.$router.push({
    //     path,
    //     query
    //   })
    // }
    jump(path, name, ...query) {
      if (!path) return undefined

      if ([...query] && [...query].length !== 0) {
        [...query].map(item => {
          this.$router.push({
            path,
            query: {
              [name]: this.$route.query[name],
              [item]: this.$route.query[item]
            }
          })
        })
      } else {
        this.$router.push({
          path,
          query: {
            [name]: this.$route.query[name]
          }
        })
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/main.js